import {
  SET_LOADING_DATA,
  GET_LIST_ALL_REQUEST,
  GET_LIST_ALL_SUCCESS,
  SET_ORDER,
  SET_ORDERBY,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SHARE_CSV
} from './product-without-picture-report-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const getAllProductWithoutPictureReportsRequest = payload => {
  return {
    type: GET_LIST_ALL_REQUEST,
    payload
  };
};

export const getAllProductWithoutPictureReportsSuccess = payload => {
  return {
    type: GET_LIST_ALL_SUCCESS,
    payload
  };
};

export const shareCSV = (payload?: any) => {
  return {
    type: SHARE_CSV,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};
